export const API_URL = process.env.REACT_APP_API_URL;
export const WEB_URL = process.env.REACT_APP_WEB_URL!;
export const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
